import { useTranslation } from 'react-i18next'

import { Button } from '#/shared/ui/button'

export function BookingButton({ onClick }: { onClick?: () => void }) {
  const { t } = useTranslation()
  return (
    <Button
      type="button"
      variant="outline"
      size="xs"
      pressEffect
      onClick={onClick}
      className="px-2.5"
    >
      {t('detailToolbar.booking')}
    </Button>
  )
}
